import http from "../utils/http";
/* istanbul ignore next */
export const fetchTenantHistory = async (
  area_id: string,
  params: string
): Promise<Response> => {
  return await http.get(`/api/areas/${area_id}/tenant-history${params}`);
};
